module.exports = __webpack_public_path__ + "img/16l010-15.fd82297e.jpg";